import { defineEntitiesSelectors } from '../utils/defineEntitiesSelectors'

export const membershipsBaseSelectors = defineEntitiesSelectors({
  type: 'memberships'
})
